/* Nolae blog — the front and category pages. Built by scripts/build-js.py in nolae-blog-theme
   from the prototype's scripts; do not edit by hand. */

/* ————— The breadcrumb trail on the theme's header —————
   The trail pins under Focal's sticky header (whatever height it has at
   the moment — it shrinks once scrolled) and, while pinned, drops its white
   pill and reads its colours off what is behind it, part by part. */
(function () {
  var LUMA = 0.6;
  var BAND = 0.03;
  var LUMA_STEP = 40;
  // The trail is on the article, category and archive pages; the index has
  // none, but its header hides and returns the same way (glass.js runs on
  // every page of the prototype).
  var crumbsEl = document.querySelector(".nolae-blog .crumbs");
  function toRgb(css) {
    var m = /^rgba?\(([^)]+)\)/.exec(css || "");
    if (!m) return null;
    var p = m[1].split(",").map(parseFloat);
    if (p.length > 3 && p[3] === 0) return null; // fully transparent
    return p;
  }

  /** Nearest painted background behind `el`, walking up past transparents. */
  function backdropOf(el) {
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      var rgb = toRgb(getComputedStyle(n).backgroundColor);
      if (rgb) return rgb;
    }
    return [255, 255, 255];
  }

  function luminance(rgb) {
    var lin = rgb.slice(0, 3).map(function (v) {
      var c = v / 255;
      return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
    });
    return 0.2126 * lin[0] + 0.7152 * lin[1] + 0.0722 * lin[2];
  }

  /* ————— Photographs —————
     backdropOf() reads painted background colours, which is right for the
     storefront's sections but says "white" for an <img>. Behind the pinned
     breadcrumb trail the backdrop is mostly article covers, so those are
     measured for real: the image is drawn to an 8×8 canvas and its pixels
     averaged. Needs the image to be CORS-readable (the cards set
     crossorigin, and the CDN allows it); a tainted or failed read counts as
     light. Cached per URL; the first sample of a new image comes back after
     it loads, via a nudge on the scroll event. */
  var lumaCache = {};

  function imageLuma(img) {
    var src = img.currentSrc || img.src;
    if (!src) return null;
    var hit = lumaCache[src];
    if (hit !== undefined) return hit === "pending" ? null : hit;
    lumaCache[src] = "pending";
    var probe = new Image();
    probe.crossOrigin = "anonymous";
    probe.onload = function () {
      try {
        var c = document.createElement("canvas");
        c.width = 8; c.height = 8;
        var ctx = c.getContext("2d");
        ctx.drawImage(probe, 0, 0, 8, 8);
        var d = ctx.getImageData(0, 0, 8, 8).data;
        var sum = 0;
        for (var i = 0; i < d.length; i += 4) sum += luminance([d[i], d[i + 1], d[i + 2]]);
        lumaCache[src] = sum / (d.length / 4);
      } catch (e) {
        lumaCache[src] = 1;
      }
      window.dispatchEvent(new Event("scroll"));
    };
    probe.onerror = function () { lumaCache[src] = 1; };
    probe.src = src;
    return null;
  }

  /** Luminance of whatever is painted at (x, y), ignoring `bar` itself: a
   *  photograph's real average, otherwise the nearest background colour. */
  function lumaAt(x, y, bar) {
    var stack = document.elementsFromPoint(x, y);
    for (var i = 0; i < stack.length; i++) {
      var el = stack[i];
      if (bar.contains(el)) continue;
      if (el.tagName === "IMG") return imageLuma(el);
      return luminance(backdropOf(el));
    }
    return 1;
  }

  /** Mean luminance just below the bar, sampled at three points across it. */

  var crumbs = crumbsEl;
  var lastCrumbY = -1e9;
  var BARE = ".crumb--home a, .crumb-chev, .crumb-slash, .crumb-w, .crumb-here";

  /* On a desktop the current page's name is split into words (.crumb-w),
     each its own part: a long article title can run from the bare page onto
     a cover, and word by word the dark stretch goes white while the rest
     stays as it is. On a phone (≤768px) the name is one part, measured
     whole — the trail is centred over a full-width column there, so it is
     over one thing or the other. Redone when a resize crosses the line. */
  var WORDS_FROM = window.matchMedia("(min-width: 769px)");

  function splitWords() {
    if (!crumbs) return;
    var want = WORDS_FROM.matches;
    crumbs.querySelectorAll(".crumb-here").forEach(function (here) {
      var split = !!here.querySelector(".crumb-w");
      if (split === want) return;
      if (!want) { here.textContent = here.textContent; here.classList.remove("is-dark"); return; }
      var words = here.textContent.split(/(\s+)/);
      here.textContent = "";
      words.forEach(function (w) {
        if (!w) return;
        if (/^\s+$/.test(w)) { here.appendChild(document.createTextNode(w)); return; }
        var span = document.createElement("span");
        span.className = "crumb-w";
        span.textContent = w;
        here.appendChild(span);
      });
    });
    lastCrumbY = -1e9;
  }
  splitWords();
  window.addEventListener("resize", splitWords);

  /** The trail's bare parts: the name itself only while it is not split. */
  function bareParts() {
    var all = crumbs.querySelectorAll(BARE);
    var parts = [];
    for (var i = 0; i < all.length; i++) {
      if (all[i].classList.contains("crumb-here") && all[i].querySelector(".crumb-w")) continue;
      parts.push(all[i]);
    }
    return parts;
  }

  /** One element's backdrop: its mean luminance. Small parts sample their
   *  centre; a wide one, five points across. null while an image behind it
   *  is still loading. */
  function backdropOfPart(el) {
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) return null;
    var mid = Math.round(r.top + r.height / 2);
    var ts = r.width > 60 ? [0.06, 0.28, 0.5, 0.72, 0.94] : [0.5];
    var sum = 0, n = 0;
    for (var i = 0; i < ts.length; i++) {
      var l = lumaAt(Math.round(r.left + r.width * ts[i]), mid, crumbs);
      if (l === null) continue; // an image still loading: sample again later
      sum += l; n++;
    }
    if (!n) return null;
    return { mean: sum / n };
  }

  function applyCrumbs() {
    if (!crumbs) return;
    var parts = bareParts();
    if (!crumbs.classList.contains("is-pinned")) {
      for (var j = 0; j < parts.length; j++) parts[j].classList.remove("is-dark");
      lastCrumbY = -1e9;
      return;
    }
    var y = window.scrollY;
    if (Math.abs(y - lastCrumbY) < LUMA_STEP) return;
    var measured = false;
    for (var i = 0; i < parts.length; i++) {
      var b = backdropOfPart(parts[i]);
      if (!b) continue; // keep this part's last skin, try again next event
      measured = true;
      var el = parts[i];
      if (b.mean < LUMA - BAND) el.classList.add("is-dark");
      else if (b.mean > LUMA + BAND) el.classList.remove("is-dark");
    }
    if (measured) lastCrumbY = y;
  }


  var headerEl = document.querySelector('.shopify-section--header, [id^="shopify-section"][id$="__header"]');
  function headerSticky() {
    if (!headerEl) return false;
    var cs = getComputedStyle(headerEl);
    return cs.position === "sticky" || cs.position === "fixed";
  }
  /** Where the trail parks: the header's resting bottom edge — its height,
   *  plus whatever is still above it near the top of the page — or the top
   *  of the window while the header is away. Read without the slide, so the
   *  trail's own `top` transition runs in step with the header's. */
  function chromeTop() {
    if (up || !headerSticky()) return 0;
    var r = headerEl.getBoundingClientRect();
    return Math.max(0, r.top) + headerEl.offsetHeight;
  }

  /* ————— Auto-hiding header, as in the prototype —————
     Scrolling down slides the store header away; scrolling back up brings
     it back (html.nolae-chrome-up, blog-article.css). Asymmetric on purpose:
     getting out of the way is immediate, coming back asks for a deliberate
     run of scrolling, so the bar does not fly in on a twitch of the wheel.
     Back at the top it is part of the opening composition again. */
  var up = false;
  var lastY = window.scrollY;
  var run = 0;
  var DELTA = 2, HIDE_AFTER = 24, REVEAL_AFTER = 120;
  function setUp(v) {
    if (v && document.body.classList.contains("lock-all")) v = false; // a drawer is open
    if (v === up) return;
    up = v;
    document.documentElement.classList.toggle("nolae-chrome-up", v);
    // The chrome is sliding: re-measure across the 320ms transition.
    [80, 200, 340].forEach(function (ms) { setTimeout(measure, ms); });
  }
  function autoHide() {
    if (!headerEl) return;
    var y = window.scrollY;
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) return;
    lastY = y;
    if (diff > 0 !== run > 0) run = 0;
    run += diff;
    if (y <= headerEl.offsetHeight) { run = 0; setUp(false); return; }
    if (run >= HIDE_AFTER) setUp(true);
    else if (run <= -REVEAL_AFTER) setUp(false);
  }

  /* The frosted band the pinned trail rides on: one sheet of glass from
     the top of the window down to the trail's lower edge, the header's own
     recipe (20% white, 20px blur), just under the header in the stacking
     order. While it is up the theme's own glass — the scrolled header's
     background and 1px border, and on a phone its body::before band — is
     switched off (blog-article.css, body.nolae-glass-on), so header and
     trail sit on the same surface instead of two blurs meeting at a seam. */
  var band = document.createElement("div");
  band.className = "nolae-glass";
  band.setAttribute("aria-hidden", "true");
  band.style.cssText = "position:fixed;left:0;right:0;top:0;height:0;background:rgba(255,255,255,0.2);-webkit-backdrop-filter:blur(20px);backdrop-filter:blur(20px);z-index:3;pointer-events:none;";
  document.body.appendChild(band);
  var lastTop = -1;
  function measure() {
    autoHide();
    if (!crumbsEl) return;
    var top = Math.round(chromeTop());
    if (top !== lastTop) { crumbsEl.style.setProperty("--chrome-top", top + "px"); lastTop = top; }
    var r = crumbsEl.getBoundingClientRect();
    // Pinned: parked at its offset, or riding along while the offset moves.
    var pinned = window.scrollY > 0 && (r.top <= top + 2 || (up && r.top <= lastRestTop + 2));
    crumbsEl.classList.toggle("is-pinned", pinned);
    band.style.height = (pinned ? Math.max(0, Math.round(r.bottom)) : 0) + "px";
    document.body.classList.toggle("nolae-glass-on", pinned);
    applyCrumbs();
  }
  var lastRestTop = 0;
  if (headerEl) lastRestTop = headerEl.offsetHeight;
  measure();
  window.addEventListener("scroll", measure, { passive: true });
  window.addEventListener("resize", measure);
  /* Focal's header shrinks and slides after the scroll stops, with no scroll
     event to go with it: the trail lands on its sticky offset a beat after
     the last measure. So the header's size is observed, and there is one
     late measure after each scroll. */
  if (headerEl && window.ResizeObserver) new ResizeObserver(function () { lastRestTop = headerEl.offsetHeight; measure(); }).observe(headerEl);
  var settle = 0;
  window.addEventListener("scroll", function () {
    if (settle) clearTimeout(settle);
    settle = setTimeout(function () { settle = 0; measure(); }, 400);
  }, { passive: true });
})();

/* Hero slider controls.
 *
 * The track is already a working slider without this file — a native scroll
 * container with snap points, which swipes on touch and keyboard-scrolls. This
 * adds the prev/next buttons and keeps the dashes in step, and nothing here is
 * required for the content to be reachable.
 *
 * Vanilla and standalone so it ports as {{ 'blog-hero.js' | asset_url |
 * script_tag }}.
 */
(function () {
  var root = document.querySelector("[data-hero]");
  if (!root) return;

  var track = root.querySelector("[data-hero-track]");
  var prev = root.querySelector("[data-hero-prev]");
  var next = root.querySelector("[data-hero-next]");
  var dots = [].slice.call(root.querySelectorAll("[data-hero-to]"));
  var slides = [].slice.call(track.children);
  if (slides.length < 2) {
    // One article: the controls would be decoration.
    if (prev) prev.hidden = true;
    if (next) next.hidden = true;
    root.querySelector("[data-hero-dots]").hidden = true;
    return;
  }

  /* ————— Auto-advance —————
     Long enough to read a headline, short enough that the third slide is not a
     secret. The dashes are driven from the same number, so the bar and the
     timer cannot drift. Overridable with data-hero-interval on the slider —
     which is how the Liquid section will expose it as a setting. */
  var INTERVAL = +root.dataset.heroInterval || 6000;
  /* Someone who asked for less motion did not ask for a carousel that moves on
     its own. The slider still works by hand; it just never advances itself, and
     the current dash sits filled rather than sweeping. */
  var STILL = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var timer = 0;
  var paused = false;

  /** Restart the fill on one dash, and blank the others. */
  function runProgress(at) {
    dots.forEach(function (d, i) {
      var fill = d.querySelector(".hero-dot-fill");
      if (!fill) return;
      fill.style.transition = "none";
      fill.style.transform = i === at && (STILL || paused) ? "scaleX(1)" : "scaleX(0)";
    });
    if (STILL || paused) return;

    var fill = dots[at] && dots[at].querySelector(".hero-dot-fill");
    if (!fill) return;
    /* Reading a layout property between the reset and the start forces the
       browser to apply the first frame — without it the two style writes are
       coalesced and the bar jumps straight to full. */
    void fill.offsetWidth;
    fill.style.transition = "transform " + INTERVAL + "ms linear";
    fill.style.transform = "scaleX(1)";
  }

  function schedule() {
    clearTimeout(timer);
    if (STILL || paused) return;
    timer = setTimeout(function () {
      /* From `index`, not measured(): a smooth scroll may still be in flight
         when this fires, and reading scrollLeft mid-flight returns the slide we
         are leaving — so the slider would advance to where it already is and
         sit there. Same reason the arrows track the index.
         The modulo is the loop: the last slide leads back to the first. */
      go((index + 1) % slides.length);
    }, INTERVAL);
  }

  /** Called whenever the slide changes, by hand or by the timer. */
  function restart(at) {
    runProgress(at === undefined ? measured() : at);
    schedule();
  }

  /** Which slide is under the scroll position. */
  function measured() {
    var w = track.clientWidth || 1;
    return Math.round(track.scrollLeft / w);
  }

  /* The slide the reader is on. Held here rather than read from scrollLeft on
     every press, because a press starts a smooth scroll that has not finished
     yet — computing the next target from a half-finished position meant two
     quick presses of `next` both landed on the same slide. A swipe writes back
     to it from the settled scroll position, so the two stay in agreement. */
  var index = measured();

  /** `at` is passed when a control was pressed, so the dash lights straight
   *  away rather than after the smooth scroll settles — and it still works if
   *  the scroll animation is interrupted or never fires an end event. */
  function sync(at) {
    if (at === undefined) at = measured();
    index = at;
    dots.forEach(function (d, i) {
      var on = i === at;
      d.classList.toggle("is-current", on);
      if (on) d.setAttribute("aria-current", "true");
      else d.removeAttribute("aria-current");
    });
    // The track does not wrap, so the ends are dead ends — say so.
    if (prev) prev.disabled = at <= 0;
    if (next) next.disabled = at >= slides.length - 1;
  }

  function go(i) {
    var n = Math.min(Math.max(i, 0), slides.length - 1);
    track.scrollTo({ left: n * track.clientWidth, behavior: "smooth" });
    sync(n);
    restart(n);
  }

  if (prev) prev.addEventListener("click", function () { go(index - 1); });
  if (next) next.addEventListener("click", function () { go(index + 1); });
  dots.forEach(function (d) {
    d.addEventListener("click", function () { go(+d.dataset.heroTo); });
  });

  /* Scroll fires continuously through a smooth scroll, so this waits for the
     settled position — it is what catches a swipe, where no button was pressed.
     The debounce is deliberately short: any longer and a fast swipe leaves the
     wrong dash lit for a noticeable beat. */
  var settle = 0;
  track.addEventListener("scroll", function () {
    clearTimeout(settle);
    settle = setTimeout(function () {
      sync();
      // A swipe is an interaction: the slide it lands on gets a full interval.
      restart();
    }, 90);
  }, { passive: true });
  window.addEventListener("resize", sync);

  /* Pause while the pointer is over the slider — nobody wants the thing they
     are reading to slide away under the cursor — and while the tab is in the
     background, where the timer would keep firing and the bar would not, so
     they would come back out of step. */
  ["mouseenter", "focusin"].forEach(function (e) {
    root.addEventListener(e, function () { paused = true; clearTimeout(timer); runProgress(measured()); });
  });
  ["mouseleave", "focusout"].forEach(function (e) {
    root.addEventListener(e, function () { paused = false; restart(); });
  });
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) { clearTimeout(timer); return; }
    restart();
  });

  sync();
  restart(measured());
})();

/* How many cards the "Latest posts" rail can show.
 *
 * The rail sits beside the slider and should end where the slider ends — a card
 * hanging below it reads as an alignment mistake. How many fit depends on the
 * slider's height, which is a ratio of its width, so it changes with every
 * viewport: four at a full-width desktop, three around 1030, two below that.
 * Rather than pick a number, this measures and hides the overflow.
 *
 * Hiding rather than trimming the markup keeps every article in the document
 * for a crawler and for a reader without JavaScript, who gets the full four.
 * In the theme the same script does the same job over a Liquid loop.
 */
(function () {
  var slider = document.querySelector("[data-hero]");
  var track = slider && slider.querySelector("[data-hero-track]");
  var rail = document.querySelector(".rail-items");
  if (!slider || !track || !rail) return;

  var cards = [].slice.call(rail.children);
  if (cards.length < 2) return;

  /* Below this the rail is stacked under the slider and there is no height to
     match — the same 820 line the hero's CSS switches on. */
  var stacked = window.matchMedia("(max-width: 819.98px)");

  function fit() {
    cards.forEach(function (c) { c.hidden = false; });
    if (stacked.matches) return;

    /* The TRACK, not the slider. .hero-slider is a stretched grid item, so its
       box grows to whatever the taller column needs — measuring it meant
       comparing the rail against a limit the rail itself was setting, and
       nothing was ever over. The track is the slide, and the slide is the
       height to match. */
    var limit = track.getBoundingClientRect().bottom;
    var bottoms = cards.map(function (c) { return c.getBoundingClientRect().bottom; });

    cards.forEach(function (c, i) {
      // 1px of tolerance: sub-pixel heights mean an exact fit rarely lands even.
      c.hidden = i > 0 && bottoms[i] > limit + 1;
    });
  }

  /* The slider's height follows its width, so this has to be re-run whenever
     the column changes — including the breakpoint crossing, which fires resize
     but not necessarily anything else. */
  var pending = 0;
  function schedule() {
    clearTimeout(pending);
    pending = setTimeout(fit, 60);
  }
  window.addEventListener("resize", schedule);
  stacked.addEventListener("change", schedule);

  /* The images decide the slider's final height, and they are still loading on
     first paint — fit once now and again once everything has settled. */
  fit();
  window.addEventListener("load", fit);
  if (typeof ResizeObserver === "function") new ResizeObserver(schedule).observe(slider);
})();

/* Category row arrows.
 *
 * Vanilla and standalone so it ports to the theme unchanged, as
 * {{ 'blog-row.js' | asset_url | script_tag }} — no imports, no build step.
 * Both behaviours degrade honestly without it: the rows are native scroll
 * containers you can swipe, and the listing shows its first page.
 */
(function () {
  /* ————— Category rows ————— */
  document.querySelectorAll(".row").forEach(function (row) {
    var scroller = row.querySelector("[data-row]");
    var prev = row.querySelector('[data-scroll="prev"]');
    var next = row.querySelector('[data-scroll="next"]');
    if (!scroller || !prev || !next) return;

    /* One card plus its gap. Measured rather than assumed, because the number
       of visible columns changes with the breakpoint. */
    function step() {
      var card = scroller.firstElementChild;
      if (!card) return scroller.clientWidth;
      var gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = scroller.scrollWidth - scroller.clientWidth;
      // 2px of tolerance: sub-pixel widths mean scrollLeft rarely lands exactly.
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max - 2;
    }

    prev.addEventListener("click", function () { scroller.scrollBy({ left: -step(), behavior: "smooth" }); });
    next.addEventListener("click", function () { scroller.scrollBy({ left: step(), behavior: "smooth" }); });
    scroller.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  });
})();

/* Tag rows that stay on one line.
 *
 * A card shows as many hashtags as its width allows and folds the rest into a
 * "+2" chip. Which ones fit depends on the tag text and the card's width, so it
 * is measured rather than assumed — and re-measured when the width changes.
 *
 * Every tag is in the markup regardless; this only hides the overflow. Without
 * the script the row simply wraps onto a second line, which is untidy but not
 * broken.
 *
 * Vanilla and standalone so it ports as {{ 'blog-tags.js' | asset_url |
 * script_tag }}.
 *
 * The row is marked `data-tagrow`, deliberately not `data-tags` — the cards
 * already use that one to carry their tag handles for the search filter.
 */
(function () {
  var rows = [].slice.call(document.querySelectorAll("[data-tagrow]"));

  function fit(row) {
    var more = row.querySelector("[data-more]");
    var pills = [].slice.call(row.children).filter(function (el) { return el !== more; });
    if (!more || pills.length < 2) return;

    // Start from everything shown, or the previous pass would measure against
    // its own result.
    pills.forEach(function (p) { p.hidden = false; });
    more.hidden = true;

    /* Wrapping is detected by vertical position: the first pill sits on the top
       line, so anything below it has wrapped. Comparing widths instead would
       mean re-deriving the gap and the flex maths by hand. */
    var top = pills[0].offsetTop;
    var firstWrapped = -1;
    for (var i = 1; i < pills.length; i++) {
      if (pills[i].offsetTop > top) { firstWrapped = i; break; }
    }
    if (firstWrapped === -1) return; // they all fit

    var visible = firstWrapped;
    function apply() {
      for (var j = 0; j < pills.length; j++) pills[j].hidden = j >= visible;
      more.hidden = false;
      more.textContent = "+" + (pills.length - visible);
    }
    apply();

    /* The chip needs room of its own, and adding it can push the row over
       again — so give back one tag at a time until the chip sits on the first
       line. At least one tag always stays: a row of nothing but "+3" says less
       than one tag and a count. */
    while (visible > 1 && more.offsetTop > top) {
      visible--;
      apply();
    }
  }

  function run() { rows.forEach(fit); }

  /* blog-filter.js builds new cards as the reader pages, searches and
     filters, and announces each batch with this event on the grid. Their rows
     replace the grid's old ones in the list; the rows elsewhere stay. */
  document.addEventListener("blog:cards", function (e) {
    var fresh = [].slice.call(e.target.querySelectorAll("[data-tagrow]"));
    rows = rows.filter(function (r) { return !e.target.contains(r) || fresh.indexOf(r) !== -1; })
      .concat(fresh.filter(function (r) { return rows.indexOf(r) === -1; }));
    fresh.forEach(fit);
  });

  var pending = 0;
  window.addEventListener("resize", function () {
    clearTimeout(pending);
    pending = setTimeout(run, 120);
  });

  run();
  // The fallback face measures differently, so re-fit once Omnes has landed.
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(run);
})();

/* Search, tag filtering and pagination for the "All articles" listing.
 *
 * The tag control is the release-calendar prototype's, in vanilla form: a
 * desktop popover and a mobile bottom sheet over one shared selection, both
 * rendered server-side and kept in step here.
 *
 * Only the first page of cards is in the markup. Everything else comes from a
 * compact JSON index (data-index on the grid) that is fetched ONCE, the first
 * time the reader pages, types or ticks a filter — never on load. Cards for
 * any other page, search or filter are then built here by cloning the blank
 * card in [data-card-template], so they are the exact markup the
 * server renders. Until the index is needed the page carries none of it.
 *
 * Standalone so it ports as {{ 'blog-filter.js' | asset_url | script_tag }}.
 */
(function () {
  var root = document.querySelector("[data-browse]");
  var grid = document.querySelector("[data-grid]");
  var pager = document.querySelector("[data-pager]");
  var empty = document.querySelector("[data-empty]");
  var skeleton = document.querySelector("[data-skeleton]");
  var loadingNote = document.querySelector("[data-loading-note]");
  var tpl = document.querySelector("[data-card-template]");
  if (!root || !grid || !pager) return;

  /* Every string this script writes comes from the grid's data-s-* attributes
     (see AllArticles) — the script carries no copy, so the theme can hand it
     translated text. `{n}` / `{tag}` are the slots. */
  var S = function (key, vars) {
    var str = grid.getAttribute("data-s-" + key) || "";
    Object.keys(vars || {}).forEach(function (k) { str = str.replace("{" + k + "}", vars[k]); });
    return str;
  };
  var PER_PAGE = +grid.dataset.perPage || 9;
  var total = +grid.dataset.total || grid.children.length;
  var totalKnown = grid.dataset.total !== "";
  // On a category page the listing is that category's alone; the index is
  // shared, so it is cut down to the scope once loaded.
  var scope = grid.dataset.scope || "";
  // …and on a subcategory page, to that subcategory within it.
  var subScope = grid.dataset.sub || "";
  var input = root.querySelector("[data-search]");

  /* Both lists — popover and sheet — plus every mirror of the selected count.
     Collected document-wide because the sheet is a sibling of .browse. */
  /* Looked up on demand, not once: the tag rows are built later from the
     index (see fillTagLists), so a list taken now would miss them. */
  function picks() { return [].slice.call(document.querySelectorAll("[data-tag]")); }
  var counters = [].slice.call(document.querySelectorAll("[data-sel-count]"));
  // Document-wide: the summary line sits after the sticky bar, not in it.
  var summary = document.querySelector("[data-summary]");
  var countEl = document.querySelector("[data-count]");
  var sheetCount = document.querySelector("[data-sheet-count]");

  /* Our own clear control, in place of the browser's search-cancel button.
     Whether it is SHOWN is not decided here — blog.css keys that off the
     input's :placeholder-shown state so the two glyphs can animate between
     each other. This only handles the press. */
  var clearSearch = root.querySelector("[data-search-clear]");

  var query = "";
  var tags = [];          // selected tag handles; empty means no tag filter
  var page = 1;

  /* ————— The index ————— */

  var index = null;      // [{ h,u,t,i,d,a,g,s,k, tagset, text }] once loaded
  var indexPromise = null;
  var imagePrefix = "";
  var indexTags = [];    // [[label, handle, count], …] for the picker
  var indexTopics = [];  // [[label, "topic:handle", count], …] for the picker
  var indexSubs = {};    // { handle: label } for the subcategories

  /** Fetches the index once; every later call gets the same promise. */
  function loadIndex() {
    if (indexPromise) return indexPromise;
    // data-index: one JSON URL per blog, comma-separated; each answers fifty
    // articles and a `next` URL for the page after (templates/blog.index.liquid).
    var urls = grid.dataset.index.split(",").filter(Boolean);
    function pages(url, acc) {
      return fetch(url, { credentials: "same-origin" })
        .then(function (r) { if (!r.ok) throw new Error(url + " → " + r.status); return r.json(); })
        .then(function (json) {
          acc.articles = acc.articles.concat(json.articles || []);
          Object.keys(json.subs || {}).forEach(function (k) { acc.subs[k] = json.subs[k]; });
          return json.next ? pages(json.next, acc) : acc;
        });
    }
    indexPromise = Promise.all(urls.map(function (u) { return pages(u, { articles: [], subs: {} }); }))
      .then(function (parts) {
        var json = { image_prefix: "", subs: {}, articles: [] };
        parts.forEach(function (p) {
          json.articles = json.articles.concat(p.articles);
          Object.keys(p.subs).forEach(function (k) { json.subs[k] = p.subs[k]; });
        });
        // Newest first across the four blogs, as the page is.
        json.articles.sort(function (a, b) { return (b.d || "").localeCompare(a.d || ""); });
        return json;
      })
      .then(function (json) {
        imagePrefix = json.image_prefix || "";
        indexSubs = json.subs || {};
        index = json.articles.map(prepare).filter(function (e) {
          return (!scope || e.y === scope) && (!subScope || e.s.indexOf(subScope) !== -1);
        });
        indexTags = countTags(index);
        indexTopics = countTopics(index);
        return index;
      })
      .catch(function (err) {
        indexPromise = null; // so the next interaction tries again
        throw err;
      });
    return indexPromise;
  }

  /** The artists of what is in scope — label, "artist:" handle, count —
   *  commonest first, then alphabetical: the "Artists" group in the picker.
   *  Counted here rather than shipped, so a category page's picker only
   *  offers the artists its articles actually carry. */
  function countTags(entries) {
    var seen = {};
    entries.forEach(function (e) {
      e.g.forEach(function (t) {
        var hit = seen[t[1]];
        if (hit) hit[2]++;
        else seen[t[1]] = [t[0], t[1], 1];
      });
    });
    return Object.keys(seen).map(function (k) { return seen[k]; })
      .sort(function (a, b) { return b[2] - a[2] || a[0].localeCompare(b[0]); });
  }

  /** Same idea as countTags, for `topic:` handles — a writer's topic tag
   *  needs no developer edit anywhere to show up here or in the picker. */
  function topicLabel(h) {
    return h.replace(/[-_]/g, " ").replace(/\b\w/g, function (c) { return c.toUpperCase(); });
  }
  function countTopics(entries) {
    var seen = {};
    entries.forEach(function (e) {
      (e.k || []).forEach(function (h) {
        var tag = "topic:" + h;
        var hit = seen[tag];
        if (hit) hit[2]++;
        else seen[tag] = [topicLabel(h), tag, 1];
      });
    });
    return Object.keys(seen).map(function (k) { return seen[k]; })
      .sort(function (a, b) { return b[2] - a[2] || a[0].localeCompare(b[0]); });
  }

  /** What each entry is matched against, worked out once. */
  function prepare(e) {
    var handles = e.s.map(function (x) { return "sub:" + x; })
      .concat(e.g.map(function (t) { return t[1]; }))
      .concat((e.k || []).map(function (x) { return "topic:" + x; }));
    e.tagset = " " + handles.join(" ") + " ";
    e.text = (e.t + " " + e.a + " " + e.g.map(function (t) { return t[0]; }).join(" ")).toLowerCase();
    return e;
  }

  /* ————— Filtering ————— */

  /* Two groups of checkboxes share the `tags` list: categories (handles that
     start with "sub:") and plain tags. Within a group the boxes read as OR —
     "Lyrics or Releases" — but between the groups they read as AND, so
     "Lyrics" + "BTS" is BTS lyrics, not every lyric and everything BTS. */
  function anyOf(has, picks) {
    return picks.some(function (t) { return has.indexOf(" " + t + " ") !== -1; });
  }

  function matches(e) {
    if (tags.length) {
      var cats = tags.filter(function (t) { return t.indexOf("sub:") === 0; });
      var topics = tags.filter(function (t) { return t.indexOf("topic:") === 0; });
      var plain = tags.filter(function (t) { return t.indexOf("sub:") !== 0 && t.indexOf("topic:") !== 0; });
      if (cats.length && !anyOf(e.tagset, cats)) return false;
      if (topics.length && !anyOf(e.tagset, topics)) return false;
      if (plain.length && !anyOf(e.tagset, plain)) return false;
    }
    if (!query) return true;
    return e.text.indexOf(query) !== -1;
  }

  /* ————— Building cards ————— */

  var SMALL_WIDTHS = [200, 400, 600, 800];
  var dateFmt = new Intl.DateTimeFormat("en-GB", { day: "numeric", month: "long", year: "numeric" });

  function imageUrl(src, w) {
    return src + (src.indexOf("?") !== -1 ? "&" : "?") + "width=" + w;
  }

  /** One card from the template, with the entry's values in every slot the
   *  server fills — the same fields lib/blog.ts's ArticleCard writes. */
  function buildCard(e) {
    var card = tpl.firstElementChild.cloneNode(true);
    // "@/blogs/…" marks a post with its own page in the prototype.
    var href = e.u.charAt(0) === "@" ? e.u.slice(1) : "https://nolae.de" + e.u;
    var img = e.i.indexOf("http") === 0 ? e.i : imagePrefix + e.i;

    var media = card.querySelector(".card-media");
    media.href = href;
    var pic = media.querySelector("img");
    pic.crossOrigin = "anonymous"; // as the server-rendered cards: glass.js reads pixels
    pic.src = imageUrl(img, 800);
    pic.srcset = SMALL_WIDTHS.map(function (w) { return imageUrl(img, w) + " " + w + "w"; }).join(", ");

    var row = card.querySelector("[data-tagrow]");
    var more = row.querySelector("[data-more]");
    row.textContent = "";
    // The chips, as lib/blog.ts pillTags: the artists, then the subcategory
    // (labels come with the index); a post with neither gets a plain "Blog".
    var tagsOf = e.g.concat(e.s.map(function (h) { return [indexSubs[h] || h, "sub:" + h]; }));
    // A post with neither (a data gap — every post should carry a sub:) gets
    // no chip at all rather than a made-up one. Set both ways: the template
    // card is built from a blank article, so its row starts out hidden.
    row.hidden = !tagsOf.length;
    tagsOf.forEach(function (t) {
      var pill = document.createElement("a");
      pill.className = "hashpill";
      var localeRoot = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/").replace(/\/$/, "");
      pill.href = localeRoot + (e.b ? "/blogs/" + e.b : "/blogs/news") + "/tagged/" + (t[1] || "").replace(":", "-");
      // As lib/blog.ts hashTag: each word capitalised as the spaces close up.
      pill.textContent = "#" + t[0].replace(/(^|\s)(\p{L})/gu, function (_, sp, c) { return c.toUpperCase(); }).replace(/\s+/g, "");
      if (t[1]) { // a real tag is a filter; the "Blog" fallback is only a label
        pill.setAttribute("role", "button");
        pill.tabIndex = 0;
        pill.setAttribute("data-tag-pick", t[1]);
      }
      row.appendChild(pill);
    });
    row.appendChild(more);

    var title = card.querySelector(".card-title a");
    title.href = href;
    title.textContent = e.t;

    var time = card.querySelector(".cardmeta time");
    if (e.d) { time.dateTime = e.d.slice(0, 10); time.textContent = e.f || dateFmt.format(new Date(e.d)); }
    else { time.removeAttribute("datetime"); time.textContent = ""; }
    var spans = card.querySelectorAll(".cardmeta > span");
    if (spans[1]) {
      if (e.a) spans[1].lastChild.nodeValue = e.a;
      else spans[1].parentNode.removeChild(spans[1]);
    }
    return card;
  }

  function fill(entries) {
    var frag = document.createDocumentFragment();
    entries.forEach(function (e) { frag.appendChild(buildCard(e)); });
    grid.textContent = "";
    grid.appendChild(frag);
    // blog-tags.js folds the overflowing hashtags on the new cards.
    grid.dispatchEvent(new CustomEvent("blog:cards", { bubbles: true }));
  }

  /* ————— Rendering ————— */

  var renderId = 0;

  /** The skeleton in place of the grid while an answer is on its way. Shown
   *  from the first qualifying keystroke — before the typing has even settled
   *  — so the reader sees the page react at once; taken down by finish().
   *  If the index is already here the answer lands in the same task, and the
   *  swap never reaches the screen. */
  var shownCount = total; // what the last finish() put on the page
  var shownPages = Math.max(1, Math.ceil(total / PER_PAGE));

  function setLoading(on) {
    if (!skeleton) return;
    skeleton.hidden = !on;
    if (loadingNote) loadingNote.hidden = !on;
    if (on) {
      grid.hidden = true;
      if (empty) empty.hidden = true;
      // No page numbers under placeholders — they belong to an answer.
      pager.hidden = true;
    } else {
      // Off without a fresh render (typing settled on nothing new): put back
      // whatever the last answer was — the grid, or the "no matches" note —
      // and its pager.
      grid.hidden = shownCount === 0;
      if (empty) empty.hidden = shownCount !== 0;
      pager.hidden = shownPages < 2;
    }
  }

  function render() {
    var filtering = tags.length > 0 || query !== "";

    /* The one state the server already rendered: no filter, page 1. As long
       as the index has not been fetched, that is what is on the page — leave
       it and only draw the pager from the known total. */
    if (!index && !filtering && page === 1) {
      finish(total, Math.max(1, Math.ceil(total / PER_PAGE)));
      return;
    }

    var mine = ++renderId;
    setLoading(true);
    loadIndex().then(function () {
      if (mine !== renderId) return; // a newer keystroke or click superseded this one
      var hits = index.filter(matches);
      var pages = Math.max(1, Math.ceil(hits.length / PER_PAGE));
      if (page > pages) page = pages;
      var from = (page - 1) * PER_PAGE;
      fill(hits.slice(from, from + PER_PAGE));
      finish(hits.length, pages);
    }).catch(function (err) {
      // Put whatever was on the page back; the reader still has that.
      if (mine === renderId) { setLoading(false); grid.hidden = false; }
      if (window.console) console.error(err);
    });
  }

  /** Everything around the grid: the summary line, the sheet's count, the
   *  badge on the chip, the empty state and the pager. */
  function finish(count, pages) {
    var filtering = tags.length > 0 || query !== "";
    if (summary) summary.hidden = !filtering;
    if (countEl) countEl.textContent = S(count === 1 ? "found-one" : "found", { n: count });
    if (sheetCount) sheetCount.textContent = S(count === 1 ? "show-one" : "show", { n: count });

    counters.forEach(function (el) {
      el.hidden = tags.length === 0;
      el.textContent = tags.length;
    });

    shownCount = count;
    shownPages = pages;
    setLoading(false);

    buildPager(pages);
  }

  /** Rebuilt rather than toggled: filtering changes how many pages there are,
   *  so the numbers themselves are part of the state. */
  function buildPager(pages) {
    pager.hidden = pages < 2;
    if (pages < 2) { pager.textContent = ""; return; }

    pager.textContent = "";
    pager.appendChild(arrow("prev", page === 1));
    var nums = document.createElement("div");
    nums.className = "pager-nums";
    window_(pages).forEach(function (n) {
      nums.appendChild(n === "gap" ? gap() : num(n));
    });
    pager.appendChild(nums);
    pager.appendChild(arrow("next", page === pages));
  }

  /** Which page numbers to print: first, last, the current one and its
   *  neighbours, with a gap marker where the run breaks.
   *  Unfiltered this list is 107 pages long — printing every number produced a
   *  row wider than the page. */
  function window_(pages) {
    var NEIGHBOURS = 2;
    var keep = [1, pages];
    for (var i = page - NEIGHBOURS; i <= page + NEIGHBOURS; i++) {
      if (i >= 1 && i <= pages) keep.push(i);
    }
    keep = keep.filter(function (n, i, a) { return a.indexOf(n) === i; }).sort(function (a, b) { return a - b; });

    var out = [];
    keep.forEach(function (n, i) {
      // A gap of exactly one page is printed rather than elided — "1 … 3" is
      // longer than "1 2 3" and hides a page for no reason.
      if (i > 0 && n - keep[i - 1] === 2) out.push(keep[i - 1] + 1);
      else if (i > 0 && n - keep[i - 1] > 2) out.push("gap");
      out.push(n);
    });
    return out;
  }

  function gap() {
    var s = document.createElement("span");
    s.className = "pager-gap";
    s.setAttribute("aria-hidden", "true");
    s.textContent = "…";
    return s;
  }

  function num(i) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "pager-num" + (i === page ? " is-current" : "");
    b.textContent = i;
    if (i === page) b.setAttribute("aria-current", "page");
    b.addEventListener("click", function () { go(i); });
    return b;
  }

  function arrow(dir, disabled) {
    var b = document.createElement("button");
    b.type = "button";
    b.className = "pager-arrow";
    b.disabled = disabled;
    b.setAttribute("aria-label", S(dir === "prev" ? "prev" : "next"));
    b.innerHTML =
      '<svg viewBox="0 0 17 14" width="17" height="14" fill="none" aria-hidden="true"><path d="' +
      (dir === "prev" ? "M17 7H2M8 1L2 7l6 6" : "M0 7h15M9 1l6 6-6 6") +
      '" stroke="currentColor" stroke-width="2"/></svg>';
    b.addEventListener("click", function () { go(dir === "prev" ? page - 1 : page + 1); });
    return b;
  }

  function go(n) {
    page = n;
    render();
    jumpToAll();
  }

  /** Scroll so the listing's heading sits at the top of the screen — after a
   *  page turn, so the reader lands on the heading rather than wherever the
   *  shorter page left the viewport, and after a pill is picked anywhere on
   *  the page.
   *
   *  The store header slides away on the way down and comes back on the way
   *  up (glass.js), so "the top of the screen" depends on which way this
   *  jump goes: a downward jump ends with no header, an upward one with the
   *  header back. Reserving header room every time — what scroll-margin did —
   *  left the heading a header's height too low after every downward jump.
   *  The thresholds are glass.js's own (HIDE_AFTER 24, REVEAL_AFTER 120).
   *
   *  With `holdChrome` the question does not arise: glass.js is asked to keep
   *  the header away for the whole jump (data-chrome-hold), so the heading
   *  always lands flush at the top, and the header is not sliding in over the
   *  results the reader just asked for. Pill picks use this. */
  var holdTimer = 0;
  var holdSettle = 0;
  var holdRelease = null;

  function jumpToAll(holdChrome) {
    var head = document.querySelector(".all .row-head");
    var bar = document.querySelector(".store-header");
    var barH = bar ? bar.offsetHeight : 0;
    var top = head.getBoundingClientRect().top + window.scrollY - 20; // a little air above the title
    var travel = top - window.scrollY;
    var willHide;
    if (holdChrome) {
      willHide = true;
      document.documentElement.setAttribute("data-chrome-hold", "");
    } else {
      var hidden = document.documentElement.classList.contains("chrome-up");
      willHide = travel >= 24 ? true : travel <= -120 ? false : hidden;
      if (top <= barH) willHide = false; // at the very top the bar is always back
    }
    var y = Math.max(0, willHide ? top : top - barH);

    if (holdChrome) {
      /* The hold comes off only once the page has actually come to rest at
         the target — NOT on scrollend, which also fires when the reader's own
         scroll ends (a phone's momentum scroll, say, stopped by the very tap
         that picked the tag) and so could release it while the jump was
         still travelling. Settled = no scroll event for a moment and within
         a few px of where we aimed; a hard stop covers a scroll that never
         quite gets there (the page too short, say). */
      if (holdRelease) holdRelease();
      var done = false;
      var release = function () {
        if (done) return;
        done = true;
        clearTimeout(holdTimer);
        clearTimeout(holdSettle);
        window.removeEventListener("scroll", onScroll);
        holdRelease = null;
        document.documentElement.removeAttribute("data-chrome-hold");
      };
      var onScroll = function () {
        clearTimeout(holdSettle);
        holdSettle = setTimeout(function () {
          if (Math.abs(window.scrollY - y) <= 3) release();
        }, 160);
      };
      holdRelease = release;
      window.addEventListener("scroll", onScroll, { passive: true });
      holdTimer = setTimeout(release, 3000);
    }

    /* Through Lenis where it is running (it owns the wheel on desktop; a
       native smooth scroll and Lenis' loop can pull against each other), with
       the reader's input locked out until it lands so the jump cannot be
       nudged off target. Native smooth scroll otherwise. */
    if (window.__lenis && typeof window.__lenis.scrollTo === "function") {
      window.__lenis.scrollTo(y, { duration: 0.9, lock: true, force: true });
    } else {
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }

  /* ————— Hashtag pills —————
     Every #tag pill on the page — hero, category rows, the grid itself — is
     a shortcut into this listing: it replaces the current selection with
     that one tag, clears the search, and scrolls here. Delegated and in the
     capture phase so pills built later are covered and nothing above them
     can swallow the click; the hero's pill sits inside the slide's link, so
     the default (following it) is cancelled. */
  /* ————— Toast ————— */

  var toastEl = document.querySelector("[data-toast]");
  var toastTimer = 0;
  var TOAST_MS = 3200; // a full sentence now; a beat longer to read it

  function toast(msg) {
    if (!toastEl) return;
    clearTimeout(toastTimer);
    toastEl.textContent = msg;
    toastEl.hidden = false;
    // Re-trigger the entrance if one is already up: drop the class, force a
    // style flush, add it back.
    toastEl.classList.remove("is-on");
    void toastEl.offsetWidth;
    toastEl.classList.add("is-on");
    toastTimer = setTimeout(function () {
      toastEl.classList.remove("is-on");
      // Let the exit transition finish before it leaves the layout.
      toastTimer = setTimeout(function () { toastEl.hidden = true; }, 260);
    }, TOAST_MS);
  }

  function pickTag(el) {
    var t = el.getAttribute("data-tag-pick");
    if (!t) return;
    // The pill's own text ("#boygroup"), so the message names exactly what
    // was clicked.
    toast(S("picked", { tag: el.textContent.trim() }));
    tags = [t];
    query = "";
    if (input) input.value = "";
    page = 1;
    setPop(false);
    setSheet(false);
    syncRows();
    render();
    jumpToAll(true);
  }

  document.addEventListener("click", function (e) {
    var el = e.target.closest && e.target.closest("[data-tag-pick]");
    if (!el) return;
    e.preventDefault();
    e.stopPropagation();
    pickTag(el);
  }, true);

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var el = e.target.closest && e.target.closest("[data-tag-pick]");
    if (!el) return;
    e.preventDefault();
    pickTag(el);
  }, true);

  /* ————— Tag selection —————
     One selection, two lists. Every row for a handle is updated, so opening the
     sheet after using the popover shows the same ticks. */

  function syncRows() {
    picks().forEach(function (b) {
      var on = tags.indexOf(b.dataset.tag) !== -1;
      b.setAttribute("aria-checked", on ? "true" : "false");
      b.parentNode.classList.toggle("sel", on);
    });
  }

  // Delegated, so rows built after load are covered too. In the CAPTURE
  // phase: the popover stops clicks from bubbling (that is what keeps the
  // click-outside handler from closing it), so a bubbling listener here
  // would never hear a tick made inside it.
  document.addEventListener("click", function (e) {
    var b = e.target.closest && e.target.closest("[data-tag]");
    if (!b) return;
    var t = b.dataset.tag;
    var at = tags.indexOf(t);
    if (at === -1) tags.push(t);
    else tags.splice(at, 1);
    page = 1;
    syncRows();
    render();
  }, true);

  /* ————— The tag rows —————
     Only the categories are in the markup; the tags come with the index and
     are built into every [data-tag-list] the first time a picker opens. */

  var rowTpl = document.querySelector("[data-tag-row-template]");
  var tagListsFilled = false;

  function fillTagLists() {
    if (tagListsFilled || !rowTpl) return;
    tagListsFilled = true;
    var lists = [].slice.call(document.querySelectorAll("[data-tag-list]"));
    var topicLists = [].slice.call(document.querySelectorAll("[data-topic-list]"));
    var notes = [].slice.call(document.querySelectorAll("[data-tag-loading]"));
    var slow = setTimeout(function () { notes.forEach(function (n) { n.hidden = false; }); }, 250);
    function fillOne(list, entries) {
      var frag = document.createDocumentFragment();
      entries.forEach(function (t) {
        var row = rowTpl.firstElementChild.cloneNode(true);
        row.setAttribute("data-tag-row", t[1]);
        var pick = row.querySelector("[data-tag]");
        pick.setAttribute("data-tag", t[1]);
        row.querySelector(".tag-row__name").textContent = t[0];
        row.querySelector(".n").textContent = t[2];
        frag.appendChild(row);
      });
      list.textContent = "";
      list.appendChild(frag);
    }
    loadIndex().then(function (json) {
      lists.forEach(function (list) { fillOne(list, indexTags); });
      topicLists.forEach(function (list) { fillOne(list, indexTopics); });
      syncRows();
    }).catch(function () {
      tagListsFilled = false; // so the next open tries again
    }).finally(function () {
      clearTimeout(slow);
      notes.forEach(function (n) { n.hidden = true; });
    });
  }

  /* ————— Desktop popover ————— */

  var picker = root.querySelector("[data-picker]");
  var toggle = picker && picker.querySelector("[data-picker-toggle]");
  var pop = picker && picker.querySelector("[data-pop]");

  var popOpenedAt = 0;

  function setPop(open) {
    if (!pop) return;
    if (open) fillTagLists();
    pop.hidden = !open;
    toggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      popOpenedAt = window.scrollY;
      var box = pop.querySelector("[data-tag-search]");
      // preventScroll: focus's own scroll-into-view would fight the page's
      // smooth scrolling if the toolbar is still settling.
      if (box) box.focus({ preventScroll: true });
    }
  }

  /* An open popover closes once the page has scrolled a little, as a native
     dropdown does. It is anchored to the chip, so it travels with the page —
     and the store header that slides back in on an upward scroll is
     translucent by design, so the rows would show through it. A small
     allowance, so the nudge of a trackpad or the focus settling does not
     snap it shut. */
  window.addEventListener("scroll", function () {
    if (pop && !pop.hidden && Math.abs(window.scrollY - popOpenedAt) > 40) setPop(false);
  }, { passive: true });

  if (toggle) {
    toggle.addEventListener("click", function (e) {
      e.stopPropagation();
      setPop(pop.hidden);
    });
    pop.addEventListener("click", function (e) { e.stopPropagation(); });
    document.addEventListener("click", function () { setPop(false); });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { setPop(false); setSheet(false); }
    });
  }

  /* ————— Mobile sheet ————— */

  var sheet = document.querySelector("[data-sheet]");

  function setSheet(open) {
    if (!sheet) return;
    if (open) fillTagLists();
    sheet.hidden = !open;
    /* The sheet scrolls its own body; letting the page scroll behind it means
       closing it drops the reader somewhere else entirely. */
    document.body.style.overflow = open ? "hidden" : "";
    if (window.__lenis) open ? window.__lenis.stop() : window.__lenis.start();
  }

  var openBtn = root.querySelector("[data-sheet-open]");
  if (openBtn) openBtn.addEventListener("click", function () { setSheet(true); });
  if (sheet) {
    sheet.addEventListener("click", function (e) {
      // The overlay closes; the sheet itself does not.
      if (e.target === sheet) setSheet(false);
    });
    [].slice.call(sheet.querySelectorAll("[data-sheet-close]")).forEach(function (b) {
      b.addEventListener("click", function () { setSheet(false); });
    });
  }

  /* ————— The two search fields ————— */

  // Tag search: narrows the list itself, in whichever container it sits.
  [].slice.call(document.querySelectorAll("[data-tag-search]")).forEach(function (box) {
    var scope = box.closest("[data-pop]") || box.closest(".sheet__group");
    var none = scope.querySelector("[data-tag-empty]");
    var list = scope.querySelector(".sheet__tags, .tag-pop__list");
    box.addEventListener("input", function () {
      var q = box.value.trim().toLowerCase();
      var shown = 0;
      // Live, not cached: the tag rows may have been built since.
      var rows = [].slice.call(scope.querySelectorAll("[data-tag-row]"));
      // Matches are shown from the top of the list; if the reader had scrolled
      // down before typing, they would otherwise be looking at empty space.
      if (list) list.scrollTop = 0;
      rows.forEach(function (r) {
        var hit = r.textContent.toLowerCase().indexOf(q) !== -1;
        r.hidden = !hit;
        if (hit) shown++;
      });
      // The "Categories" / "Tags" headings stay while searching, so the
      // reader can still tell the two kinds of match apart — but a heading
      // with nothing left under it goes, rather than labelling empty space.
      // Each heading owns the rows that follow it up to the next heading.
      var heading = null, inGroup = 0;
      [].slice.call(list ? list.children : []).forEach(function (el) {
        if (el.classList.contains("tag-group__title")) {
          if (heading) heading.hidden = inGroup === 0;
          heading = el; inGroup = 0;
        } else if (el.hasAttribute("data-tag-row") && !el.hidden) {
          inGroup++;
        } else if (el.hasAttribute("data-tag-list")) {
          // The tags sit one level down, in the list the index fills.
          inGroup += el.querySelectorAll("[data-tag-row]:not([hidden])").length;
        }
      });
      if (heading) heading.hidden = inGroup === 0;
      if (none) none.hidden = shown !== 0;
    });
  });

  if (clearSearch && input) {
    clearSearch.addEventListener("click", function () {
      input.value = "";
      query = "";
      page = 1;
      render();
      // Focus goes back to the field: the reader cleared it to type again.
      input.focus();
    });
  }

  /* Article search. Not on every keystroke: a search starts once the reader
     has typed at least MIN_CHARS and then paused for SETTLE_MS — each render
     rebuilds nine cards, and the very first one fetches the index, so firing
     on "t", "tw", "twi"… would be wasted work and a flicker of results.
     Fewer than MIN_CHARS counts as no search: deleting back to two letters
     returns the unfiltered list rather than leaving stale results up. */
  var MIN_CHARS = 3;
  var SETTLE_MS = 400;
  var timer = 0;

  function applySearch() {
    var raw = input.value.trim().toLowerCase();
    // One or two characters: the skeleton simply stays up — the reader is
    // mid-word and the third character is what starts the search. Only an
    // emptied field (or the clear control) brings the full list back.
    if (raw.length > 0 && raw.length < MIN_CHARS) return;
    var next = raw.length >= MIN_CHARS ? raw : "";
    if (next === query) { setLoading(false); return; } // nothing to redo — e.g. a trailing space
    query = next;
    page = 1;
    render();
  }

  if (input) {
    if (input.form) input.form.addEventListener("submit", function (e) { e.preventDefault(); });
    input.addEventListener("input", function () {
      clearTimeout(timer);
      var raw = input.value.trim().toLowerCase();
      var next = raw.length >= MIN_CHARS ? raw : "";
      // React on the keystroke itself: the skeleton goes up from the FIRST
      // character — the page answers the typing at once — even though the
      // search itself waits for the third. It stays up through one and two
      // characters and comes down with the results (or with an emptied field).
      if (raw.length > 0 && raw.length < MIN_CHARS) {
        setLoading(true);
        // …and a search still in flight from a longer text must not land on
        // top of it: the skeleton is the answer to one or two characters.
        renderId++;
      }
      else if (next !== query) setLoading(true);
      else setLoading(false);
      timer = setTimeout(applySearch, SETTLE_MS);
    });
    // A search field's clear button fires `search`, not `input`, in Safari;
    // clearing needs no settle time.
    input.addEventListener("search", function () {
      clearTimeout(timer);
      applySearch();
    });
  }

  /* ————— Reset ————— */

  [].slice.call(document.querySelectorAll("[data-clear]")).forEach(function (b) {
    b.addEventListener("click", function () {
      query = "";
      tags = [];
      page = 1;
      if (input) input.value = "";
      syncRows();
      render();
    });
  });

  /* ————— A filter carried in the URL —————
     A tag pill on an article page links to its category page with the tag
     in the query (…/pages/k-pop-news?tag=artist:cortis&label=%23CORTIS#all):
     on arrival the
     filter is applied exactly as a pill click here would apply it — toast,
     the listing, the jump to "All articles" — and the query is dropped from
     the address so a reload or a share is the plain page. In Liquid this is
     the sub:/artist: tagged view (F/G) resolving to the same state. */
  var fromUrl = null, fromLabel = null;
  try { var qs = new URLSearchParams(location.search); fromUrl = qs.get("tag"); fromLabel = qs.get("label"); } catch (e) {}
  if (fromUrl) {
    var pill = document.querySelector('[data-tag-pick="' + fromUrl.replace(/"/g, "") + '"]');
    // The pill's text as the link passed it (…&label=%23CORTIS), else a
    // card's pill on the page, else #CamelCase from the handle.
    var label = fromLabel || (pill ? pill.textContent.trim()
      : "#" + fromUrl.replace(/^[a-z]+:/, "").split(/[-_\s]+/).map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); }).join(""));
    try { history.replaceState(null, "", location.pathname + location.hash); } catch (e) {}
    tags = [fromUrl];
    page = 1;
    syncRows();
    render();
    toast(S("picked", { tag: label }));
    // After the page has laid out, so the jump lands on the section.
    setTimeout(function () { jumpToAll(true); }, 80);
  } else {
    render();
  }
  if (!totalKnown) {
    (window.requestIdleCallback || function (f) { setTimeout(f, 1200); })(function () {
      loadIndex().then(function () {
        total = index.length;
        if (!tags.length && !query && page === 1) finish(total, Math.max(1, Math.ceil(total / PER_PAGE)));
      }).catch(function () {});
    });
  }
})();
